/**
 * Rascunho TEMPORÁRIO genérico (só no browser, sessionStorage) para etapas do
 * wizard de caso — persiste a ida-volta entre os steps. NÃO vai para o Firebase.
 * Limpo ao concluir/cancelar o caso (ChildCaseService.cancelCaseRegistry).
 *
 * Uso: StepDraftUtil.save('deworming', token, { ... }).
 */
export class StepDraftUtil {
    private static key(ns: string, token: string): string {
        return `nm-${ns}:${token || 'anon'}`;
    }

    static save(ns: string, token: string, data: any): void {
        try {
            sessionStorage.setItem(StepDraftUtil.key(ns, token), JSON.stringify(data));
        } catch {
        }
    }

    static load<T = any>(ns: string, token: string): T | null {
        try {
            const raw = sessionStorage.getItem(StepDraftUtil.key(ns, token));
            return raw ? JSON.parse(raw) as T : null;
        } catch {
            return null;
        }
    }

    static clear(ns: string, token: string): void {
        try {
            sessionStorage.removeItem(StepDraftUtil.key(ns, token));
        } catch {
        }
    }
}
